// Period type for the modernized day/week/month report contract (Point 13).
// Used by Expense, Hiring, Performance, and Work-Life Balance report endpoints
// as the `periodType` query field (with a `referenceDate`).
//
// IMPORTANT: these numeric values are DIFFERENT from CalendarViewTypeEnum
// (which attendance uses). Do not interchange the two.
export const ReportPeriodTypeEnum = Object.freeze({
  Day: 0,
  Week: 1,
  Month: 2,
});

export const ReportPeriodTypeLabel = Object.freeze({
  [ReportPeriodTypeEnum.Day]: "Day",
  [ReportPeriodTypeEnum.Week]: "Week",
  [ReportPeriodTypeEnum.Month]: "Month",
});

// Options for an AntD Select (Day / Week / Month period picker).
export const ReportPeriodTypeOptions = Object.entries(ReportPeriodTypeLabel).map(
  ([value, label]) => ({ value: Number(value), label })
);
